import common from 'store/modules/common/api'

export const api = {
  getEntity: () => common.httpClient.get(`/api/services/app/FileAttachments/GetAll`, common.options()).then(r => common.processResponse(r)),
  downloadFile: (id, onProgress) => common.httpClient.get(`/api/services/app/FileAttachments/DownloadFile?id=${id}`, { ...common.options(), onDownloadProgress: onProgress, responseType: 'blob' }),
  delete: (id) => common.httpClient.delete(`/api/services/app/FileAttachments/Delete?id=${id}`, common.options()).then(r => common.processResponse(r))
}
